var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75 8.5C3.75 7.94772 4.19772 7.5 4.75 7.5H30.25C30.8023 7.5 31.25 7.94772 31.25 8.5C31.25 9.05228 30.8023 9.5 30.25 9.5H4.75C4.19772 9.5 3.75 9.05228 3.75 8.5ZM3.75 17C3.75 16.4477 4.19772 16 4.75 16H30.25C30.8023 16 31.25 16.4477 31.25 17C31.25 17.5523 30.8023 18 30.25 18H4.75C4.19772 18 3.75 17.5523 3.75 17ZM4.75 24.5C4.19772 24.5 3.75 24.9477 3.75 25.5C3.75 26.0523 4.19772 26.5 4.75 26.5H30.25C30.8023 26.5 31.25 26.0523 31.25 25.5C31.25 24.9477 30.8023 24.5 30.25 24.5H4.75Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenu);
export default __webpack_public_path__ + "static/media/icon-menu.f941d7d25fa2fe104a8867ea9f86a497.svg";
export { ForwardRef as ReactComponent };